/* card/types */
import * as t from "io-ts";
import { BinCodec } from "../processor/types";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

export const CardTypeCodec = t.intersection([
  t.type({
  }),
  t.partial({
    type: t.string,
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type CardType = t.TypeOf<typeof CardTypeCodec>;

export const DeletedCardTypeCodec = t.intersection([
  t.type({
  }),
  t.partial(
    {}
  )
]);

export type DeletedType = t.TypeOf<typeof DeletedCardTypeCodec>

export const DataCodec = t.intersection([
  t.type({
  }),
  t.partial({
    id: t.string,
    type: t.string,
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const CardCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "CardTypeCodec"
);

export type CardTypeCodec = t.TypeOf<typeof CardCodec>;

export enum CardTypeActionTypes {
  FETCH = "@@cardtype/FETCH",
  FETCH_SUCCESS = "@@cardtype/FETCH_SUCCESS",
  FETCH_ERROR = "@@cardtype/FETCH_ERROR",
  SAVE_REQUEST = "@@cardtype/SAVE_REQUEST",
  SAVE_SUCCESS = "@@cardtype/SAVE_SUCCESS",
  SAVE_ERROR = "@@cardtype/SAVE_ERROR",
}

export interface CardTypeState {
  readonly loading: boolean;
  readonly data: CardTypeCodec | undefined;
  readonly errors?: string;
}
